// extracted by mini-css-extract-plugin
export default {"input-container":"styles_input-container__DxjjE"};